/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import ServicesLayout from '../../components/ServicesLayout';
import Login from './Login';
import NotFound from '../notFound/NotFound.js';

const title = 'Logowanie';

export default {

  path: '/login',

  async action(ctx) {
    const { query } = ctx;
    return {
      title,
      component: <ServicesLayout><NotFound/></ServicesLayout>,
    };
  },
};



// WEBPACK FOOTER //
// src/routes/login/index.js